export default "__VITE_ASSET__BcYWGbe5__"